import React from 'react';
import { motion } from 'framer-motion';

const CareerCard = ({ career, index }) => {
  const getDemandColor = (demand) => {
    switch (demand.toLowerCase()) {
      case 'very high':
        return 'text-green-600 bg-green-100';
      case 'high':
        return 'text-blue-600 bg-blue-100';
      case 'medium':
        return 'text-yellow-600 bg-yellow-100';
      case 'low':
        return 'text-red-600 bg-red-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="career-card"
      style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
        padding: '2rem',
        margin: '1rem 0',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        cursor: 'pointer'
      }}
      whileHover={{ 
        y: -5,
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
        <span style={{ fontSize: '2rem', marginRight: '1rem' }}>{career.icon}</span>
        <div>
          <h3 style={{ 
            fontSize: '1.5rem', 
            fontWeight: '600', 
            color: '#333',
            marginBottom: '0.5rem'
          }}>
            {career.name}
          </h3>
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${getDemandColor(career.demand)}`}>
            {career.demand} Demand
          </span>
        </div>
      </div>

      <p style={{ 
        color: '#666', 
        marginBottom: '1.5rem',
        lineHeight: '1.6'
      }}>
        {career.description}
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
        <div>
          <strong style={{ color: '#333' }}>Salary Range:</strong>
          <p style={{ color: '#666', marginTop: '0.25rem' }}>{career.salary}</p>
        </div>
        <div>
          <strong style={{ color: '#333' }}>Duration:</strong>
          <p style={{ color: '#666', marginTop: '0.25rem' }}>{career.duration}</p>
        </div>
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        <strong style={{ color: '#333', display: 'block', marginBottom: '0.5rem' }}>Top Colleges:</strong>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
          {career.topColleges.map((college, idx) => (
            <span 
              key={idx}
              style={{
                background: '#f3f4f6',
                color: '#374151',
                padding: '0.25rem 0.75rem',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}
            >
              {college}
            </span>
          ))}
        </div>
      </div>

      <div>
        <strong style={{ color: '#333', display: 'block', marginBottom: '0.5rem' }}>Required Skills:</strong>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
          {career.skills.map((skill, idx) => (
            <span 
              key={idx}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                padding: '0.25rem 0.75rem',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default CareerCard; 